<template>
  <div class="apparea">
    <div class="col-md-9 filter-cont dVacation-pack vh-100 m-auto" v-if="isLoading || hotels.length === 0">
      <ContentLoading type="product" />
    </div>
    <div v-else>
      <!----- header area start ----->
      <header class="header-area" v-if="isDesktopApp">
        <div class="container">
          <div class="d-flex justify-content-center">
            <figure class="logo bonauf-app-logo" @click="gotoHome"><img :src="`${speedSizeDomain}/assets/img/app/logo.png`" alt="#" title="" /></figure>
            <button class="btn-close pr-2"  @click="gotoDealFilterPage">
              <i class="fa-solid fa-chevron-right ml-5"></i>
            </button>
          </div>
        </div>
      </header>
      <!----- header area stop ----->
      <main class="body_warrper">

        <!-------- banner area start -------->
        <section class="banner-area">
          <div class="container">
            <div class="banner">
              <carousel :slides="imageList" :showThumb="true" :numThumb="4" :defaultImage="destinationImage" :altText="hotelName" v-show="imageList.length>0"/>
            </div>
          </div>
        </section>
        <!-------- banner area stop -------->
        <!------ kremlin area start ------>
        <section class="kremlin-area">
          <div class="container">
            <!------- heading area start (R5 B21 — premium hotel header) ------->
            <div class="heading bnf-hotel-heading">
              <h1 class="bnf-hotel-name">{{ hotelName }}</h1>
              <div class="bnf-hotel-rating-row" v-if="rating>2 && categoryCode !== 'Organize_tour_packages'">
                <div class="bnf-hotel-rating">
                  <b-form-rating
                    class="ui rating"
                    v-model="rating"
                    variant="warning"
                    locale="he"
                    readonly
                  ></b-form-rating>
                </div>
                <span class="bnf-hotel-rating-label">{{ rating === 5 ? 'דירוג 5 כוכבים' : rating === 4 ? 'דירוג 4 כוכבים' : 'דירוג 3 כוכבים' }}</span>
              </div>
              <span class="bnf-hotel-basis-pill" v-if="basisName">
                <i class="fas fa-utensils" aria-hidden="true"></i>
                {{ basisName }}
              </span>
            </div>
            <!------- heading area stop ------->
            <!------ kremlin list area start ------->
            <div class="kremlin-list">
              <ul class="d-flex flex-row">
                <li>
                  <figure class="kremlin-box">
                    <img :src="`${speedSizeDomain}/assets/img/app/icon3.png`" alt="#" title="" />
                    <figcaption>{{ addressString }}</figcaption>
                  </figure>
                </li>
                <li>
                  <figure class="kremlin-box">
                    <img :src="`${speedSizeDomain}/assets/img/app/icon2.png`" alt="#" title="" />
                    <figcaption>{{betweenDateString}}</figcaption>
                  </figure>
                </li>
                <li>
                  <figure class="kremlin-box">
                    <img :src="`${speedSizeDomain}/assets/img/app/icon1.png`" alt="#" title="" />
                    <figcaption>{{personString}}</figcaption>
                  </figure>
                </li>
              </ul>
            </div>
            <!------ kremlin list area stop ------->
          </div>
        </section>
        <!------ kremlin area stop ------>

        <!------ trust signals strip start ------>
        <section class="trust-signals-section">
          <div class="container">
            <div class="trust-signals" aria-label="trust">
              <span class="trust-item"><i class="fas fa-lock"></i> תשלום מאובטח SSL</span>
              <span class="trust-item"><i class="fas fa-shield-alt"></i> פרטיות מוגנת</span>
              <span class="trust-item"><i class="fas fa-headset"></i> תמיכה טלפונית</span>
            </div>
          </div>
        </section>
        <!------ trust signals strip stop ------>

        <!------- flightdetails area start ------->
        <section class="flightdetails-area">
          <ReadMore :message="description_t1" v-if="categoryCode === 'Organize_tour_packages' && device === 'mobile'" :mobileShow="false" moreClass="bold-text" />
          <ReadMore :fixedText="description_t2_fixed" :message="description_t2" :mobileShow="true" v-if="categoryCode === 'Organize_tour_packages' && device === 'mobile'"/>
          <CollapseList :data="product" :categoryName="categoryCode" />
          <div class="bnf-flight-section-heading">
            <span class="bnf-flight-section-icon" aria-hidden="true">
              <i class="fas fa-plane-departure"></i>
            </span>
            <h2 class="bnf-flight-section-title">פרטי הטיסה</h2>
            <p class="bnf-flight-section-subtitle">סקירת זמני הטיסה וכבודה</p>
          </div>
        </section>
        <!------- flightdetails area stop ------->

        <!------ plaindetails area start ------->
        <div v-if="!availableFlight">
          <section class="plaindetails-area">
            <div class="container">
              <div class="plaindetails-box">
                <h5>{{ $t("flight-only.unavailable-flight") }}</h5>
              </div>
            </div>
          </section>
        </div>
        <section class="plaindetails-area">
          <div class="container" v-if="flightItems.length>0">
            <flight-item-app
              :flight="flightItems[idxFlight]"
              :baggagePriceInfo="baggagePriceInfo"
              :categoryName="categoryCode"
              type="product"
            />
            <div class="select-flight d-flex bnf-select-flight"  v-if="!isOrganizeTour && flightItems.length>1 && !isOdysseySite">
              <div class="selectflhtbtn m-auto btn-primary bnf-flight-toggle-btn" id="selectflhtbtn" v-b-toggle="`filter-content`" role="button" tabindex="0">
                <img class="bnf-toggle-icon-img" :src="`${speedSizeDomain}/assets/img/flight.png`" alt="" />
                <span class="bnf-toggle-text">{{ $t('product-page.more-flight-option') }}</span>
              </div>
            </div>
            <b-collapse class="filter-cont dVacation-pack" :id="`filter-content`" v-model="visibleMoreFlights">
              <flight-item-app
                v-for="(item, inx) in flightItems"
                :key="inx"
                :flight="item"
                :baggagePriceInfo="baggagePriceInfo"
                :idx="inx"
                :selectIdx="idxFlight"
                :categoryName="categoryCode"
                type="product"
                @change="changeFlightIndex"
              />
            </b-collapse>
            <div class="bnf-room-pick-section">
              <span class="bnf-room-pick-icon" aria-hidden="true">
                <i class="fas fa-bed"></i>
              </span>
              <h3 class="bnf-room-pick-title">בחירת החדר שלך</h3>
              <p class="bnf-room-pick-subtitle">בחר את הרכב, סוג החדר ובסיס האירוח</p>
            </div>
          </div>

        </section>
        <!------ plaindetails area stop ------->

        <price-area-app :product="product" @message="messageFromChild" :hotelName="hotelName" :destinationCityName="destinationName" :includesText="includesText"/>

      </main>
    </div>
  </div>
</template>

<script>
import { BFormRating, VBToggle, BCollapse } from 'bootstrap-vue';
import dayjs from 'dayjs';
import bannerImageDestination from '@/utils/bannerImageDestination';
import imageUrlMixin from '@/utils/imageUrlMixin';

import TemplateProductPage from './TemplateProductPage';

export default {
  name: 'ProductPageApp',
  components: {
    Carousel: () => import('@/components//atoms/Carousel'),
    ReadMore: () => import('@/components/hotelFlight/atoms/Readmore'),
    CollapseList: () => import('@/components/hotelFlight/CollapseList'),
    ContentLoading: () => import('@/components/atoms/ContentLoading'),
    FlightItemApp: () => import('@/components/atoms/FlightItemApp'),
    PriceAreaApp: () => import('@/components/hotelFlight/ProductPriceAreaApp'),
    BFormRating,
    BCollapse,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  extends: TemplateProductPage,
  mixins: [bannerImageDestination, imageUrlMixin],
  data() {
    return {
      paxes: { adult: 0, child: 0, infant: 0 },
    };
  },
  computed: {
    addressString() {
      if (!this.product) return '';
      return this.categoryCode === 'Organize_tour_packages' ? this.product.hotels[0].cityName : this.product.hotels[0].address;
    },
  },
  watch: {
    lang() {
      this.updateLabelWithLang();

      this.personString = this.getPersonString(
        this.paxes.adult, this.paxes.child, this.paxes.infant,
      );
      this.getBetweenDateString();
      this.getItineraryDetail();
    },
  },
  async created() {
    this.$store.commit('SET_CURRENT_PAGE', 'product');
    document.body.classList.add('productPage');
    this.activeHotel = this.$route.query.laId;

    window.sessionStorage.setItem('dealType', this.query.categoryId);

    if (this.subjectCategory.length === 0) {
      this.$store.dispatch('FETCH_SUBJECT_CATEGORY');
    }

    window.sessionStorage.setItem('marketerURL', this.$route.fullPath);
    window.sessionStorage.setItem('BookingDataID', '');
    const isBlankData = await this.fetchData();
    if (!isBlankData) return;

    this.analysisProductData();

    this.updateLabelWithLang();
  },
  mounted() {
    if (this.isOdysseySite) this.$store.commit('SET_SELECTED_ODYSSEY_AGENT_CODE', this.query.odyAgentCode || this.agentContent.odyAgentCode);
  },
  methods: {
    gotoHome() {
      this.$router.push('/');
    },
    async fetchData() {
      // this.discounted = Number(this.query.discount);

      if (!this.query.packId || !this.query.laId || !this.query.categoryId || !this.query.dateFrom || !this.query.flights || !this.query.adult
        || !this.query.roomType || !this.query.roomClass) {
        this.$bvModal.msgBoxOk(
          this.$t('search-result.dont-remove-query'),
          {
            title: this.$t('product-page.expire-title'),
            dialogClass: 'noSearchResult',
            okVariant: 'success',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          },
        );
        return false;
      }

      await this.$store.dispatch('FETCH_PRODUCT', this.query);

      if (this.product?.hotels === undefined || this.product?.hotels?.length === 0) {
        this.$bvModal
          .msgBoxOk(this.$t('product-page.expire-message'), {
            title: this.$t('product-page.expire-title'),
            okVariant: 'danger',
            okTitle: this.$t('product-page.go-back'),
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(() => {
            this.$router.push('/');
          })
          .catch(() => {
            // An error occurred
          });
        return false;
      }

      // if (document.querySelector('.st-content')) document.querySelector('.st-content').scrollTo(0, 0);
      return true;
    },
    getItineraryDetail() {
      if (this.categoryCode === 'Organize_tour_packages') {
        this.description_t1 = this.product.Itinerary?.include;
        if (this.product?.Itinerary?.itineraryDetail) {
          this.description_t2_fixed = this.product.Itinerary.itineraryDetail
            .filter((item, index) => index < 2)
            .map((item, index) => `<h3><img src="${this.speedSizeDomain}/assets/img/app/icon4.png" alt=""> <p>${this.$t('product-page.day')} ${index + 1}. ${item.header}</h3>${item.text}</p>`).join('<br>');
          this.description_t2 = this.product.Itinerary.itineraryDetail.filter((item, index) => index > 1)
            .map((item, index) => `<h3><img src="${this.speedSizeDomain}/assets/img/app/icon4.png" alt=""> <p>${this.$t('product-page.day')} ${index + 3}. ${item.header}</h3>${item.text}</p>`)
            .join('<br>');
        }
        this.description_t3 = this.product.notesTranslation[this.lang];
      }
    },
    getBetweenDateString() {
      if (this.product && this.product.flights) {
        const checkIn = dayjs(this.product.flights[0]?.FlightDetail[0]?.FL_Date).add(Number(this.product.hotel_shift_1), 'day'),
          checkOut = checkIn.add(Number(this.product.duration_1), 'day');
        if (this.lang === 'he') {
          this.tripDuration = `${this.getWeek(checkIn)} ${dayjs(checkIn).format('DD/MM/YY')} - ${this.getWeek(checkOut)} ${dayjs(checkOut).format('DD/MM/YY')} (${this.hotels[0]?.duration} ${this.$t('search-result.night')})`;
          this.betweenDateString = this.tripDuration;
        } else {
          this.tripDuration = `${this.getWeek(checkIn)} ${dayjs(checkIn).format('DD/MM/YY')} -
            ${this.getWeek(checkOut)} ${dayjs(checkOut).format('DD/MM/YY')} (${this.hotels[0]?.duration} ${this.$t('search-result.night')})`;
          this.betweenDateString = this.tripDuration;
        }
      }
    },
    updateLabelWithLang() {
      if (this.product && this.product.translations) {
        const hotelID = this.product.hotels[0].La_ID;
        this.hotelName = this.product.translations.hotelName[hotelID][this.lang] || this.product.hotels[0].hotelName;
        const hotelCityCode = this.product?.hotels[0]?.city;
        this.categoryName = this.product.category?.name[this.lang] || this.product.category?.name?.en;
        this.categoryName = this.categoryName.replace('חבילות נופש', 'חבילת נופש');
        this.destinationName = this.product.translations?.city[hotelCityCode][this.lang] || this.product?.hotels[0]?.cityName;
        const basisCode = this.hotels[this.idxHotel]?.basisName;
        this.basisName = this.product.translations?.basisName?.[basisCode]?.[this.lang] ?? basisCode;

        const body = this.categoryCode === 'Organize_tour_packages' ? {
          dest: Object.keys(this.product.translations.city)[0],
          yearMonth: this.query.dateFrom.substr(0, 7),
          subjectIds: this.product ? this.subjectCategory.find((sub) => (sub.subjectCodes.includes(String(this.product.subj_id)))).id : '',
          categoryId: this.query.categoryId,
          adult: this.query.adult,
          child: this.query.child,
          infant: this.query.infant,
        } : {
          dest: Object.keys(this.product.translations.city)[0],
          fromDate: this.query.dateFrom,
          // toDate: this.product?.flights[0]?.FlightDetail[1]?.FL_Date,
          toDate: dayjs(this.query.dateFrom).add(Number(this.product.duration_1), 'day').format('YYYY-MM-DD'),
          categoryId: this.query.categoryId,
          adult: this.query.adult,
          child: this.query.child,
          infant: this.query.infant,
        };

        if (this.query.utm_source) body.utm_source = this.query.utm_source;
        if (this.isLanding) body.utm_source = this.landingInfo.utm_source;
        if (this.marketerId) body.marketerId = this.marketerId;
        if (this.isFcAgentMarketerMode) body['fc-agent-mode'] = '';

        const searchQuery = `/search-result?${new URLSearchParams(body).toString()}`;

        this.linkData = {
          text: this.product.category?.name[this.lang] || this.product.category?.name?.en,
          dest: this.product.translations?.city[hotelCityCode][this.lang] || this.product?.hotels[0]?.cityName,
          stage: this.$t(this.stageLabel[this.bookingStage]),
          searchQuery,
        };

        this.remarks = this.product.remarkTranslation[this.lang] || this.product.remark;
        this.description_t3 = this.product.notesTranslation[this.lang];
      }
    },
    gotoDealFilterPage() {
      this.$router.push(`/deal-filter/app?channel=App`);
    },
  },
};

</script>

<style scoped>
/* ===== Trust signals strip on product page ===== */
.trust-signals-section {
  padding: 8px 0;
}
.trust-signals-section .trust-signals {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 14px;
  padding: 10px 14px;
  margin: 4px auto 12px;
  background: #f7faff;
  border: 1px solid #e1e9f5;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  color: #2d4a6b;
  max-width: 720px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}
.trust-signals-section .trust-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.trust-signals-section .trust-item i {
  color: #28a745;
  font-size: 13px;
}

/* ===== kremlin-list — premium 3-column grid (R5 B22) ===== */
.kremlin-area .kremlin-list >>> ul {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin: 16px auto;
  padding: 0;
  list-style: none;
  max-width: 720px;
}
.kremlin-area .kremlin-list >>> ul li {
  display: flex;
  align-items: stretch;
  margin: 0;
  padding: 0;
  list-style: none;
}
.kremlin-area .kremlin-list >>> .kremlin-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  text-align: center;
  width: 100%;
  margin: 0;
  padding: 14px 8px 12px;
  background: #ffffff;
  border: 1px solid #e1e9f5;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
  position: relative;
  overflow: hidden;
}
.kremlin-area .kremlin-list >>> .kremlin-box::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #1c7ed6 0%, #fb6d2f 100%);
  opacity: 0.85;
}
.kremlin-area .kremlin-list >>> ul li:nth-child(1) .kremlin-box::before {
  background: linear-gradient(90deg, #fb6d2f 0%, #fbb040 100%);
}
.kremlin-area .kremlin-list >>> ul li:nth-child(2) .kremlin-box::before {
  background: linear-gradient(90deg, #1c7ed6 0%, #5ba9f0 100%);
}
.kremlin-area .kremlin-list >>> ul li:nth-child(3) .kremlin-box::before {
  background: linear-gradient(90deg, #28a745 0%, #5ec27a 100%);
}
.kremlin-area .kremlin-list >>> .kremlin-box:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
}
.kremlin-area .kremlin-list >>> .kremlin-box img {
  width: 30px;
  height: 30px;
  object-fit: contain;
  margin-top: 4px;
  opacity: 0.9;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.08));
}
.kremlin-area .kremlin-list >>> .kremlin-box figcaption {
  font-size: 11px !important;
  line-height: 1.35 !important;
  color: #1c4e80 !important;
  font-weight: 600 !important;
  font-family: 'ploni', 'Poppins', 'Segoe UI', Tahoma, Arial, sans-serif !important;
  word-break: break-word;
  overflow-wrap: break-word;
  width: 100%;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  letter-spacing: 0;
}
@media (max-width: 380px) {
  .kremlin-area .kremlin-list >>> ul {
    gap: 6px;
  }
  .kremlin-area .kremlin-list >>> .kremlin-box {
    padding: 10px 5px 8px;
  }
  .kremlin-area .kremlin-list >>> .kremlin-box img {
    width: 26px;
    height: 26px;
  }
  .kremlin-area .kremlin-list >>> .kremlin-box figcaption {
    font-size: 10px !important;
  }
}

/* ===== "אפשרויות טיסה נוספת" — premium inviting CTA (R5 B31) ===== */
.bnf-select-flight {
  margin: 22px auto 16px;
  display: flex !important;
  justify-content: center;
}
.bnf-flight-toggle-btn {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 22px;
  background: linear-gradient(135deg, #ffffff 0%, #f7faff 100%) !important;
  color: #1c4e80 !important;
  border: 1.5px solid #cfe2ff !important;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.22s ease;
  min-height: 48px;
  box-shadow: 0 2px 8px rgba(28, 126, 214, 0.1);
  position: relative;
  overflow: hidden;
}
/* Subtle accent dot indicator */
.bnf-flight-toggle-btn::before {
  content: '';
  position: absolute;
  top: 8px;
  right: 12px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #28a745;
  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.2);
  animation: bnf-pulse-dot 2s infinite;
}
@keyframes bnf-pulse-dot {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.3); opacity: 0.7; }
}
.bnf-flight-toggle-btn:hover,
.bnf-flight-toggle-btn:focus {
  background: linear-gradient(135deg, #eef6ff 0%, #d6e9ff 100%) !important;
  border-color: #1c7ed6 !important;
  box-shadow: 0 4px 12px rgba(28, 126, 214, 0.22);
  transform: translateY(-1px);
  outline: none;
}
.bnf-flight-toggle-btn .bnf-toggle-icon-img {
  width: 18px;
  height: 18px;
  object-fit: contain;
  flex: 0 0 18px;
}
.bnf-flight-toggle-btn .bnf-toggle-text {
  display: inline-block;
  flex: 0 1 auto;
  text-align: center;
  line-height: 1.2;
}
.bnf-flight-toggle-btn {
  text-align: center;
}

/* ===== Room pick heading ===== */
.room-pick-heading {
  font-size: 17px;
  font-weight: 600;
  color: #0e436b;
  margin: 24px 0 12px;
}

/* ====================================================================== */
/* R5 B21: Premium hotel-header (name + rating + basis pill)               */
/* ====================================================================== */
.bnf-hotel-heading {
  display: flex !important;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 18px auto 8px !important;
  padding: 18px 16px;
  max-width: 720px;
  position: relative;
  border: none !important;
  background: linear-gradient(180deg, rgba(28, 78, 128, 0.78) 0%, rgba(28, 126, 214, 0.92) 100%) !important;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(2px);
}
.bnf-hotel-name {
  font-size: 26px !important;
  font-weight: 800 !important;
  color: #ffffff !important;
  margin: 0 0 10px !important;
  letter-spacing: 0.3px;
  line-height: 1.2 !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.55), 0 1px 2px rgba(0, 0, 0, 0.4);
  font-family: 'ploni', 'Poppins', 'Segoe UI', Tahoma, Arial, sans-serif !important;
}
.bnf-hotel-rating-row {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 0 auto 10px;
  padding: 6px 14px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 999px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
.bnf-hotel-rating .b-rating,
.bnf-hotel-rating .form-control {
  background: transparent !important;
  border: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  height: auto !important;
  min-width: 100px;
}
.bnf-hotel-rating .b-rating-star {
  padding: 0 1px !important;
  font-size: 16px !important;
}
.bnf-hotel-rating-label {
  font-size: 12px;
  font-weight: 600;
  color: #92400e;
  font-family: 'ploni', 'Poppins', sans-serif !important;
  white-space: nowrap;
  background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);
  padding: 3px 10px;
  border-radius: 999px;
  border: 1px solid #ffd97a;
  letter-spacing: 0.2px;
}
.bnf-hotel-basis-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);
  color: #92400e;
  border: 1px solid #ffd97a;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  box-shadow: 0 2px 6px rgba(146, 64, 14, 0.12);
}
.bnf-hotel-basis-pill i {
  font-size: 11px;
  color: #f59e0b;
}
@media (max-width: 479px) {
  .bnf-hotel-heading {
    padding: 14px 12px 6px;
  }
  .bnf-hotel-name {
    font-size: 22px !important;
  }
  .bnf-hotel-rating .b-rating-star {
    font-size: 14px !important;
  }
  .bnf-hotel-basis-pill {
    font-size: 12px;
    padding: 6px 14px;
  }
}

/* ===== Premium section heading — shared style for flight + room sections ===== */
.bnf-flight-section-heading {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 28px auto 18px;
  padding: 18px 60px;  /* extra side padding so floating accessibility / Vercel widgets don't overlap text */
  max-width: 720px;
  position: relative;
}
.bnf-flight-section-heading::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #1c7ed6 0%, #fb6d2f 100%);
  border-radius: 2px;
}
.bnf-flight-section-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-bottom: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #fff4ec 0%, #ffe6d3 100%);
  border: 2px solid #ffffff;
  box-shadow: 0 4px 12px rgba(251, 109, 47, 0.18), 0 0 0 4px rgba(251, 109, 47, 0.08);
}
.bnf-flight-section-icon i {
  font-size: 22px;
  color: #fb6d2f;
}
.bnf-flight-section-title {
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 6px;
  letter-spacing: 0.2px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
.bnf-flight-section-subtitle {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.92);
  margin: 0;
  line-height: 1.4;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

/* ===== Premium "Room selection" section header ===== */
.bnf-room-pick-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 28px auto 18px;
  padding: 18px 16px;
  max-width: 720px;
  position: relative;
}
/* Decorative gradient accent line above */
.bnf-room-pick-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #fb6d2f 0%, #1c7ed6 100%);
  border-radius: 2px;
}
.bnf-room-pick-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-bottom: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #eef6ff 0%, #d6e9ff 100%);
  border: 2px solid #ffffff;
  box-shadow: 0 4px 12px rgba(28, 126, 214, 0.18), 0 0 0 4px rgba(28, 126, 214, 0.08);
}
.bnf-room-pick-icon i {
  font-size: 22px;
  color: #1c7ed6;
}
.bnf-room-pick-title {
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 6px;
  letter-spacing: 0.2px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
.bnf-room-pick-subtitle {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.92);
  margin: 0;
  line-height: 1.4;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
@media (max-width: 479px) {
  .bnf-room-pick-section {
    margin: 22px auto 14px;
    padding: 14px 12px;
  }
  .bnf-room-pick-icon {
    width: 44px;
    height: 44px;
    margin-bottom: 10px;
  }
  .bnf-room-pick-icon i {
    font-size: 18px;
  }
  .bnf-room-pick-title {
    font-size: 19px;
  }
  .bnf-room-pick-subtitle {
    font-size: 12px;
  }
}

@media (max-width: 479px) {
  .bnf-flight-section-heading {
    margin: 22px auto 14px;
    padding: 14px 50px;
  }
  .bnf-flight-section-icon {
    width: 44px;
    height: 44px;
    margin-bottom: 10px;
  }
  .bnf-flight-section-icon i {
    font-size: 18px;
  }
  .bnf-flight-section-title {
    font-size: 19px;
  }
  .bnf-flight-section-subtitle {
    font-size: 12px;
  }
  .trust-signals-section .trust-signals {
    font-size: 11px;
    gap: 8px;
    padding: 8px 10px;
    margin: 4px 8px 10px;
  }
  .trust-signals-section .trust-item i {
    font-size: 11px;
  }
  .kremlin-area .kremlin-list >>> ul {
    gap: 6px;
  }
  .kremlin-area .kremlin-list >>> .kremlin-box figcaption {
    font-size: 11px;
  }
  .bnf-flight-toggle-btn {
    width: 100%;
    max-width: 320px;
  }
  .room-pick-heading {
    font-size: 16px;
    margin: 18px 12px 10px;
  }
}
</style>

